import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get, has, orderBy } from 'lodash';
import moment from 'moment';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import InfiniteScroll from '../../components/InfiniteScroll';
import MenuAbout from '../../components/MenuAbout';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import FooterForm from '../../components/FooterForm';
import { colors } from '../../styles';

const styles = css`
  .blogpost_wrapper {
    padding-top: 60px;
    padding-bottom:90px;
    border-top: 3px solid ${colors.color3};
  }
  .blogpost {
    display: block;
    position: relative;
    padding: 0 0 45px 0;
    &:after {
      content: '';
      background-color: #CFCFCF;
      width: 75px;
      height: 3px;
      bottom: 0;
      left: 0;
      display: block;
    }
    img {
      width: 100%;
      margin: 0 0 15px 0;
    }
    .blogpost_media {
      width: 100%;
      padding-top: 52.5%;
      background-size: cover;
      background-position: top center;
      margin: 0 0 25px 0;
    }
    .blogpost_title {
      font-weight: 800;
      font-size: 16px;
      color: #000000;
      text-transform: uppercase;
      position: relative;
      margin: 0 0 30px 0;
      @media (min-width: 480px) {
        font-size: 23px;
      }
    }
    .blogpost_date {
      font-weight: 800;
      font-size: 13px;
      color: #8A8A8A;
      display: inline-block;
    }
    .blogpost_categories {
      font-weight: 800;
      font-size: 13px;
      color: ${colors.color2};
      display: inline-block;
      margin: 0 0 0 10px;
      padding: 0 0 0 10px;
      border-left: 1px solid ${colors.color3Darker};
      a {
        color: ${colors.color2};
        font-size: 13px;
      }
    }
  }
  @media (min-width: 992px) {
    .blogpost {
      &:after {
        background-color: ${colors.color1};
        width: 125px;
      }
    }
  }

  .Blog_tagList, .Blog_categoryList {
    clear: both;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .Blog_tag, .Blog_category {
    float: left;
    a {
      color: #444;
      padding: 4px 8px;
      font-size: 12px;
      &:hover {
        color: ${colors.color1}
      }
    }
  }

  .clearfix {
    clear: both;
  }
`;

class Blogposts extends React.Component {
  constructor(props) {
    super(props);

    this.perPage = 10;
    this.state = {
      limit: this.perPage,
    };
  }

  nextPage = () => {
    this.setState({
      limit: this.state.limit + this.perPage,
    });
  }

  render() {
    const { page, blogposts } = this.props;
    const { limit } = this.state;

    return (
      <div className={styles}>
        <PageWrapper>
          <InsideHeader
            h1={`${page.page_title[0].title}`}
            h1Pre={`${page.page_title[0].pretitle}`}
            leadText={`${page.lead_copy}`}
          />
          <MenuAbout />
          <div className="container blogpost_wrapper">
            <div className="row">
              <div className="col-12">
                <div className="row">
                  {
                    orderBy(blogposts, 'date', 'desc').slice(0, limit).map(post => (
                      <div className="col-lg-6" key={post._id}>
                        <Link name="blogpost-detail" className="blogpost" params={{ blogpostTitle: post.title }}>
                          <div className="blogpost_media" style={{ backgroundImage: `url(${buildThumbnailUrl(post.logo.contentUrl, { width: 800, height: 800 })})` }} />
                          <h4>
                            <span className="blogpost_date">
                              {
                                has(post, 'date') &&
                                moment(get(post, 'date')).format('MMMM D, YYYY')
                              }
                            </span>
                            <span className="blogpost_categories">
                              {post.categories}
                            </span>
                          </h4>
                          <h3 className="blogpost_title">{post.title}</h3>
                        </Link>
                      </div>
                    ))
                  }
                  <InfiniteScroll
                    action={() => this.nextPage()}
                    message="Load More"
                    messageAfter={2}
                    finished={blogposts.length <= limit}
                  />
                </div>
              </div>
              {/* <div className="col-3">
                <h3 className="clearfix">Categories</h3>
                <ul className="Blog_categoryList">
                  {
                    categories.map(category => (
                      <li key={category} className="Blog_category">
                      <Link name="blog-category" params={{ blogCategory: category }}>
                      {category}</Link></li>
                    ))
                  }
                </ul>

                <h3 className="clearfix">Tags</h3>
                <ul className="Blog_tagList">
                  {
                    tags.map(tag => (
                      <li key={tag} className="Blog_tag">
                      <Link name="blog-tag" params={{ blogTag: tag }}>{tag}</Link></li>
                    ))
                  }
                </ul>
              </div> */}
            </div>
          </div>
          <FooterForm />
        </PageWrapper>
      </div>
    );
  }
}

Blogposts.propTypes = {
  blogposts: PropTypes.arrayOf(PropTypes.object).isRequired,
  page: PropTypes.object.isRequired,
};

export default withData({
  blogposts: true,
  page: 'blog_posts',
})(Blogposts);



// WEBPACK FOOTER //
// ./src/pages/Blogposts/index.js